import { WorkoutExitReason } from '@/api/workout/types/exit-reason';

export function toggleExitReason(selected: WorkoutExitReason[], reason: WorkoutExitReason): WorkoutExitReason[] {
  return selected.includes(reason) ? selected.filter(item => item !== reason) : [...selected, reason];
}

export function resolveExitReasonText(selected: WorkoutExitReason[], text: string): string | undefined {
  if (!selected.includes(WorkoutExitReason.Other)) return undefined;
  const trimmed = text.trim();
  return trimmed ? trimmed : undefined;
}

export function canSubmitEarlyExit(selected: WorkoutExitReason[]): boolean {
  return selected.length > 0;
}
